import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { callApi, ErrorAlert, SuccessAlert } from '../crud/utils';
import './../Login.css';
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Loading from "../Loading";
import useApp from '../AppContext';
import { t } from './../i18n'

function ChangePassword() {
    const app = useApp();
    const [newPassword, setNewPassword] = useState("");
    const [error, setError] = useState(null);
    const [successMessage, setSuccessMessage] = useState(null);
    const [confirmPassword, setConfirmPassword] = useState("");
    const [isBtnActive, setIsBtnActive] = useState(true);
    const [isBtnActiveFlg, setIsBtnActiveFlg] = useState(true);
    const [isChangePassActiveFlg, setIsChangePassActiveFlg] = useState(true);
    const navigate = useNavigate();
    const language = localStorage.getItem('preferredLanguage') || app.sessionToken?.Language


    useEffect(() => {
        setIsBtnActive(newPassword !== "" && confirmPassword !== "" && newPassword === confirmPassword);
    }, [newPassword, confirmPassword]);

    async function handleChangePassword() {
        if (newPassword !== confirmPassword) {
            setError(t('changePassword.apiError', language));
            return;
        }
        setIsBtnActiveFlg(false);
        setIsBtnActive(false);

        const requestBody = {
            newPassword: newPassword,
        };

        const url = `${app.serverUrl}/api/changepassword`;
        try {
            const response = await callApi('POST', url, app.sessionToken, requestBody);

            if (response.error) {
                setError(response.error);
                setIsBtnActive(true);
                setIsBtnActiveFlg(true)
                return;
            }

            setSuccessMessage(t('changePassword.successMessage', language));
            setIsBtnActiveFlg(true)
            setIsChangePassActiveFlg(false)
            setTimeout(() => {
                navigate("/login", { replace: true });
            }, 2500);
        } catch (err) {
            setError(err.message);
            setIsBtnActive(true);
            setIsBtnActiveFlg(true);
        }
    }

    function handleGoBack() {
        setIsBtnActive(true);
        navigate("/login", { replace: true });
    }
    const parsedCustomStyle = app.sessionToken?.CustomStyle
        ? JSON.parse(app.sessionToken.CustomStyle)
        : {};

    const logoPath = parsedCustomStyle.Logo
        ? `${app.serverUrl}${parsedCustomStyle.Logo}`
        : 'images/Logo-Yard.png';

    return (
        <>
            <SuccessAlert message={successMessage} setMessage={setSuccessMessage} language={language} />
            <ErrorAlert message={error} setMessage={setError} />
            <div className='container-for-all-login' style={{ color: app.theme === 'dark' ? 'white' : '#000' }}>
                <img
                    style={{ height: "200px" }}
                    src={logoPath}
                    alt='Company-Logo'
                />
                <Form onSubmit={(e) => e.preventDefault()} style={{ background: app.theme === "dark" ? "#4e4e4eff" : "white" }}>
                    <h4 className="p-2">{t('changePassword.title', language)}</h4>
                    <p className='subtitle'>{t('changePassword.subtitle', language)}</p>
                    {isChangePassActiveFlg && (
                        <>
                            <Form.Group className="mb-2">
                                <Form.Label>{t('changePassword.newPasswordLabel', language)} <b>*</b></Form.Label>
                                <Form.Control
                                    type="password"
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                    placeholder={t('changePassword.newPasswordPlaceholder', language)}
                                    required
                                />
                            </Form.Group>

                            <Form.Group className="mb-2">
                                <Form.Label> {t('changePassword.confirmPasswordLabel', language)} <b>*</b></Form.Label>
                                <Form.Control
                                    type="password"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    placeholder={t('changePassword.confirmPasswordPlaceholder', language)}
                                    required
                                />
                            </Form.Group>
                        </>
                    )}

                    {newPassword !== confirmPassword && confirmPassword.length > 0 && (
                        <p style={{ color: "#b5265f", fontSize: "14px" }}><i className="bi bi-exclamation-circle" style={{ marginRight: "5px" }} />   {t('changePassword.passwordsMismatch', language)}</p>
                    )}

                    <div className='container-signup-split-inputs mt-4'>
                        <Button onClick={handleGoBack} variant="secondary" className='secondary-btn-signup'>
                            {t('common.backButton', language)}
                        </Button>
                        <Button
                            onClick={handleChangePassword}
                            variant="primary"
                            type="submit"
                            className='primary-btn-signup'
                            disabled={!isBtnActive}
                        >
                            {t('common.changeButton', language)}
                        </Button>
                    </div>
                </Form>
            </div>
            <img src={app.theme === "light" ? '/images/Entersoft-Logo-Login-light.png' : '/images/Entersoft-Logo-Login-dark.png'} alt='Logo-Entersoft' className='Entersoft-Logo-Login' />
            {logoPath !== 'images/Logo-Yard.png' && <img src={app.theme === "light" ? '/images/Aberon-Logo-Login-light.png' : '/images/Aberon-Logo-Login-dark.png'} alt='Logo-Aberon' className='Aberon-Logo-Login' />}
            {!isBtnActiveFlg && <Loading />}
        </>
    );
}

export default ChangePassword;
